import React from "react"
import Icon from "../icon"
import type { IconName } from "../icon"
import { OldIconButtonBase } from "./old-icon-button-base"
import type { OldIconButtonBaseProps } from "./old-icon-button-base"

type OldIconButtonProps = {
  /** Icon name from the design system icon library */
  icon: IconName
} & Omit<OldIconButtonBaseProps, "children">

/**
 * @deprecated Use `Button` from `@kit/design/button` composing an `Icon` child
 * and a `VisuallyHidden` label. Migrate with the `migrate-old-buttons` skill.
 */
const OldIconButton = React.forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  OldIconButtonProps
>(({ icon, ...props }, ref) => {
  return (
    <OldIconButtonBase {...props} ref={ref}>
      <Icon name={icon} />
    </OldIconButtonBase>
  )
})

export { OldIconButton, OldIconButton as IconButton }
